import { Row } from 'antd';
import React, { Fragment, useEffect } from 'react';
import { useInject } from '../common';
import { useNavigate, useParams } from 'react-router-dom';
import useCustomerNavigation from '../Hooks/NavigationHook';
import { PAGES, CUSTOMER_ACTIONS } from '../constants';

const Cart = () => {
  const { selfSignupCustomerService } = useInject();
  const { subscriptionId } = useParams();
  const customerNavigation = useCustomerNavigation();
  const navigate = useNavigate();

  useEffect(() => {
    async function evaluateSubscription() {
      console.log('subscriptionid', subscriptionId);

      if (subscriptionId?.length != 36) {
        navigate('/');
      }

      const existingCustomer =
        await selfSignupCustomerService.getCustomer(subscriptionId);
      if (existingCustomer?.id) {
        const outcome =
          await selfSignupCustomerService.verifySubscriptionStatus(
            existingCustomer.place_id,
          );
        if (outcome?.existingSubscription === true) {
          customerNavigation(
            PAGES.PLAN_EXISTS,
            CUSTOMER_ACTIONS.PLAN_EXISTS,
            existingCustomer,
          );
        } else {
          existingCustomer.showBuildingPlan = false;
          customerNavigation(
            PAGES.REVIEW,
            CUSTOMER_ACTIONS.CART,
            existingCustomer,
          );
        }
      } else {
        customerNavigation(
          PAGES.CART_NOT_FOUND,
          CUSTOMER_ACTIONS.PLAN_EXISTS,
          existingCustomer,
        );
      }
    }
    evaluateSubscription();
  }, []);
  return (
    <Fragment>
      <Row type="flex" justify="center"></Row>
    </Fragment>
  );
};

export default Cart;
